var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullyRenewableGas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 5.2C38.3 5.6 35.7 4.7 34.4 2.7C34.3 2.6 34.1 2.5 34 2.5C33.6 2.9 33.9 3.6 34 4C34.5 5.4 35.6 6.5 37 6.8C38.5 7.3 39.9 6.6 40.5 5.2ZM40.5 5.1C39.8 9.1 34 7.4 33.7 4.1C33.6 3.6 33.4 2.8 33.9 2.4C34.2 2.3 34.3 2.5 34.5 2.6C36 4.4 38.2 4.9 40.5 5.1Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6 4.9C45.9 4.6 48.1 4 49.5 2.1C49.6 2 49.8 1.8 50.1 1.9C50.6 2.3 50.4 3.1 50.4 3.6C50.2 7 44.5 8.8 43.6 4.9ZM43.7 4.9C44.3 6.4 45.8 7 47.2 6.4C48.7 6.1 49.7 5 50.1 3.5C50.2 3 50.4 2.3 50.1 2C50 2 49.8 2.1 49.7 2.3C48.5 4.3 45.9 5.2 43.7 4.9Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 25.4C9.5 25.4 8.8 28.5 11.2 33.2C13.6 37.9 15.7 43 15.4 45C15 47 16.8 49.8 17.1 51.1C17.4 52.4 18.3 57.5 20.4 56.8L22.6 56.1C23.2 55.9 23.3 55.2 22.8 54.8C21.6 53.9 20 52.1 19.6 48.5C18.9 42.7 20.8 38.2 19.6 35.3C18.4 32.4 18.4 25.8 15.1 24.6C11.8 23.5 9.5 25.4 9.5 25.4Z",
    fill: "#00A997",
    stroke: "#00A997",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1 45.7L17.3 39.4L12 38.5L12.9 46.4C12.9 46.4 13 47.7 13.8 48.9V51.2C13.8 51.5 14 51.7 14.3 51.7C14.6 51.7 14.8 51.5 14.8 51.2V50.2C15 50.3 15.2 50.5 15.4 50.6V52.3C15.4 52.6 15.6 52.8 15.9 52.8C16.2 52.8 16.4 52.6 16.4 52.3V51C16.7 51.1 17.1 51.1 17.5 51.1H17.6V52.3C17.6 52.6 17.8 52.8 18.1 52.8C18.4 52.8 18.6 52.6 18.6 52.3V51C18.9 50.9 19.1 50.8 19.3 50.7V51.3C19.3 51.6 19.5 51.8 19.8 51.8C20.1 51.8 20.3 51.6 20.3 51.3V50C22.6 48.4 23.1 45.7 23.1 45.7Z",
    fill: "#FF989A",
    stroke: "#FF989A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9 22.2C43.4 7.59999 22.8 7.69999 13.5 16.6C10.2 19.8 8.2 24.7 8.2 24.7C8.2 24.7 6.6 27.5 7.5 32.6C8.4 37.7 8.9 43.4 8 45.2C7 47 7.9 50.2 7.8 51.5C7.6 52.9 7 58 9.2 58H11.5C12.1 58 12.4 57.3 12.1 56.9C11.3 55.7 10.3 53.5 11 50C12.1 44.3 15.1 40.5 14.9 37.4C14.9 37.1 14.9 36.8 14.9 36.4C15.1 36.3 17.3 35.3 19.5 35.4C22.7 35.5 24.3 38.2 26.8 41C29.3 43.9 32.3 44.2 34.9 43.8C37.5 43.4 48.2 40.1 50.3 30.5C50.9 27.8 51.7 27.2 52.6 27.7C52.2 25.4 51.6 23.4 50.9 22.2Z",
    fill: "#FFF4DE",
    stroke: "#FFF4DE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 38.1C53.1 35 53.2 31.1 52.6 27.8C51.7 27.3 50.9 27.9 50.3 30.6C48.1 40.2 37.4 43.5 34.9 43.9C32.4 44.3 29.3 44 26.8 41C24.4 38.2 22.8 35.5 19.5 35.4C19.3 35.4 19.1 35.4 18.9 35.4C16.6 35.5 14.5 36.6 13.1 38.4C12.4 39.3 11.7 40.2 11.4 40.9C12.5 42.6 16.4 47.7 22.8 49.7C28.3 51.4 36.4 51.7 43.2 47.3C45 50.7 47.1 54.5 47.6 55C47.6 55 48.8 54.9 50.2 53.8C51.7 52.7 49.1 53.2 48.5 52.1C48.2 51.5 47.1 48.4 46 45C48.1 43.3 49.9 41 51.5 38.1Z",
    fill: "#00A997",
    stroke: "#00A997",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2 35.1C35.1 37.8 34.6 40.7 34.9 43.7C35.5 49 36.4 57.2 36.7 57.6C37.2 58.1 40 58.2 40 57.9C40 57.6 38.8 55.5 38.8 54.3C38.8 53.1 40.9 39.4 41.5 38.7C42.6 37.5 37 33 37 33L36.2 35.1Z",
    fill: "#FFF4DE",
    stroke: "#FFF4DE",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8 26.4C9.8 26.4 12.1 23.9 10.5 20.9C8.5 17.4 -1.3 9.7 2.7 5.6C5.1 3.1 7.4 3.8 8.4 4.2C8.1 4.3 8.1 4.7 8.2 5C7.1 4.5 5.2 4.3 3.2 6.6C0.2 10.1 11.2 18.3 12.2 21.9C13.2 25.5 10.9 28.3 10.9 28.3C10.9 28.3 9.9 27.6 9.8 26.4Z",
    fill: "#E5DBCA",
    stroke: "#E5DBCA",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19999 4.99999C8.19999 4.99999 9.49999 6.29999 10.2 6.09999C10.9 5.89999 10.1 5.59999 10.1 5.59999C10.1 5.59999 13.8 5.29999 12.6 3.99999C11.4 2.69999 9.19999 4.49999 8.39999 4.19999C7.59999 3.89999 8.19999 4.99999 8.19999 4.99999Z",
    fill: "#00A997",
    stroke: "#00A997",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2 26.9C23.3 23.8 23.1 20.4 22 17.3C21 14.2 22.6 12.9 24.5 11.1C20.3 12 15.8 14.1 13 16.8C9.69999 20 7.59999 25.5 7.39999 27.3C7.59999 27.5 7.89999 27.8 8.09999 28C9.49999 29.4 17.1 30 20.2 26.9Z",
    fill: "#00A997",
    stroke: "#00A997",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 9.2C50.6 9.8 49.8 10.3 48.6 9.4V9.5C47.7 7.6 46.3 6.4 45.4 6C44 5.3 43.7 5 42 5C40.4 5 40 5.3 38.6 6C37.7 6.5 36.4 7.6 35.5 9.5C34.3 10.4 33.5 9.9 32.8 9.3C32.1 8.7 28.9 6.5 25.8 7.4C26.2 13.8 33.2 13.6 33.7 13.3C34.1 13 34.6 13.1 34.6 13.3C34.6 13.4 34.6 13.5 34.6 13.6C34.6 18.1 36.6 22.9 37.2 25C37.9 27.1 36.6 27.5 36.6 30.1C36.6 32.7 41.9 32.7 41.9 32.7C41.9 32.7 47.2 32.7 47.2 30.1C47.2 27.5 46 27.1 46.6 25C47.3 22.9 49.2 18.1 49.2 13.6C49.2 13.5 49.2 13.4 49.2 13.3C49.2 12.7 49.7 13 50.2 13.3C50.7 13.7 57.8 13.8 58.1 7.4C55.1 6.4 52 8.6 51.3 9.2Z",
    fill: "#00A997",
    stroke: "#00A997",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7 20.9C44.7 23.4 45.3 25.2 46.9 26C46.9 25.7 47 25.3 47.1 24.9C47.7 22.9 49.5 18.3 49.7 14.1C46.3 14.1 44.7 17.3 44.7 20.9Z",
    fill: "#E5DBCA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8 20.9C44.8 22.7 45.5 24.8 47.2 25.6L46.6 26C46.6 25.4 46.8 24.8 47 24.4C48.1 22.1 48.9 19.6 49.1 17C49.2 16 49.3 15 49.4 14L49.9 14.5C46.6 14.7 44.9 18 44.8 20.9ZM44.7 20.9C44.5 17.1 45.8 13.2 50.3 13.5C50.1 17.8 47.8 21.8 47.4 26V26.7C44.7 25.8 44.6 23.3 44.7 20.9Z",
    fill: "#E5DBCA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3 20.9C39.3 17.4 37.6 14.5 34.2 14.4C34.4 18.6 36.3 22.9 37 24.9C37.1 25.3 37.2 25.7 37.2 26C38.8 25.1 39.3 23.4 39.3 20.9Z",
    fill: "#E5DBCA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3 20.9C39.2 17.9 37.3 15 34.3 14.6L34.5 14.4C34.5 17.8 36.4 21.1 37.4 24.3C37.6 24.8 37.7 25.3 37.7 25.9L37 25.5C38.6 24.7 39.3 22.6 39.3 20.9ZM39.4 20.9C39.4 22.8 39.5 25.3 37.5 26.4L36.8 26.8C36.8 25.6 36.4 24.5 35.9 23.3C34.9 20.5 34.4 17.4 34 14.4V14.2H34.3C38.3 13.9 39.6 17.5 39.4 20.9Z",
    fill: "#E5DBCA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3 28.8C37.2 29.3 37.1 29.8 37.1 30.6C37.1 33.2 42.4 33.2 42.4 33.2C42.4 33.2 47.7 33.2 47.7 30.6C47.7 29.9 47.6 29.4 47.5 29C46 28 44.3 27.4 42.4 27.4C40.5 27.3 38.8 27.9 37.3 28.8Z",
    fill: "#FF989A",
    stroke: "#FF989A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7 14.8C46.6 14.5 46.3 14.2 46 14.1C45.4 13.8 44.8 14 44.4 14.5L44.3 14.6C44.1 14.8 44 15 44 15.4C44 15.6 44 15.8 44.1 15.9C44.2 16.1 44.3 16.2 44.3 16.2C44.4 16.3 44.5 16.4 44.7 16.5C45 16.7 45.3 16.7 45.6 16.7C45.8 16.7 46 16.6 46.2 16.5C46.4 16.4 46.6 16.2 46.7 15.9C46.8 15.7 46.8 15.5 46.8 15.3C46.8 15.1 46.7 14.9 46.7 14.8Z",
    fill: "#101C1E",
    stroke: "#101C1E",
    strokeWidth: 0.755,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M40 14.8C39.9 14.5 39.6 14.2 39.3 14.1C38.7 13.8 38.1 14 37.7 14.5L37.6 14.6C37.4 14.8 37.3 15.1 37.3 15.5C37.3 15.7 37.3 15.9 37.4 16C37.5 16.2 37.6 16.3 37.6 16.3C37.7 16.4 37.8 16.5 38 16.6C38.3 16.8 38.6 16.8 38.9 16.8C39.1 16.8 39.3 16.7 39.5 16.6C39.7 16.5 39.9 16.3 40 16C40.1 15.8 40.1 15.6 40.1 15.4C40.1 15.1 40 14.9 40 14.8Z",
    fill: "#101C1E",
    stroke: "#101C1E",
    strokeWidth: 0.755,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4 29.2C45.3 29 45.1 28.8 44.9 28.7C44.5 28.5 44.1 28.6 43.8 29C43.7 29.2 43.6 29.3 43.6 29.6C43.6 29.7 43.6 29.9 43.7 30C43.7 30.1 43.8 30.2 43.8 30.2C43.9 30.3 44 30.3 44 30.4C44.2 30.5 44.4 30.6 44.6 30.5C44.7 30.5 44.9 30.4 45 30.4C45.2 30.3 45.3 30.2 45.4 30C45.5 29.9 45.5 29.7 45.5 29.6C45.5 29.4 45.5 29.3 45.4 29.2Z",
    fill: "#101C1E",
    stroke: "#101C1E",
    strokeWidth: 0.5179,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3 29.2C41.2 29 41 28.8 40.8 28.7C40.4 28.5 40 28.6 39.7 29C39.6 29.2 39.5 29.3 39.5 29.6C39.5 29.7 39.5 29.9 39.6 30C39.6 30.1 39.7 30.2 39.7 30.2C39.8 30.3 39.9 30.3 39.9 30.4C40.1 30.5 40.3 30.6 40.5 30.5C40.6 30.5 40.8 30.4 40.9 30.4C41.1 30.3 41.2 30.2 41.3 30C41.4 29.9 41.4 29.7 41.4 29.6C41.4 29.4 41.3 29.3 41.3 29.2Z",
    fill: "#101C1E",
    stroke: "#101C1E",
    strokeWidth: 0.5179,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullyRenewableGas);
export default __webpack_public_path__ + "static/media/fully-renewable-gas.b2426f01c2b9c3ce30b99814e83552b3.svg";
export { ForwardRef as ReactComponent };